import { RU } from './Locales/RU';

export const resources = {
    RU,
} as const;
